export const questionnairesEs = {
  nav: {
    field: 'Servicio de campo',
    cockpit: 'Cabina de servicio de campo',
    runs: 'Ejecuciones',
    templates: 'Cuestionarios',
    results: 'Resultados del cuestionario',
  },
  permissions: { denied: 'No tiene el permiso requerido para el cuestionario.' },
  statuses: {
    DRAFT: 'Borrador',
    PUBLISHED: 'Publicado',
    ARCHIVED: 'Archivado',
    IN_PROGRESS: 'En progreso',
    PAUSED: 'Pausado',
    COMPLETED: 'Completado',
    ABANDONED: 'Abandonado',
    SYNC_PENDING: 'Sincronización pendiente',
    SYNC_FAILED: 'Fallo de sincronización',
  },
  sync: {
    online: 'En línea',
    offline: 'Desconectado',
    syncing: 'Sincronizando',
    pending: 'Pendiente',
    failed: 'Error',
    synced: 'Sincronizado',
    retry: 'Reintentar sincronización',
    conflict: 'El servidor tiene una versión más reciente. Revise el conflicto.',
  },
  questionTypes: {
    SHORT_TEXT: 'Texto corto',
    LONG_TEXT: 'Texto largo',
    NUMBER: 'Número',
    DECIMAL: 'Decimal',
    CURRENCY: 'Moneda',
    PERCENTAGE: 'Porcentaje',
    PERCENT: 'Porcentaje',
    DATE: 'Fecha',
    TIME: 'Hora',
    DATE_TIME: 'Fecha y hora',
    DATETIME: 'Fecha y hora',
    YES_NO: 'Sí / No',
    CHECKBOX: 'Casilla de verificación',
    SINGLE_CHOICE: 'Elección simple',
    RADIO: 'Elección simple',
    MULTIPLE_CHOICE: 'Elección múltiple',
    MULTI_CHOICE: 'Elección múltiple',
    DROPDOWN: 'Desplegable',
    COMBOBOX: 'Opción buscable',
    RATING_SCALE: 'Escala de calificación',
    STAR_RATING: 'Calificación por estrellas',
    SLIDER: 'Deslizador',
    EMAIL: 'Dirección de correo electrónico',
    PHONE: 'Número de teléfono',
    URL: 'Dirección web',
    ADDRESS: 'Dirección',
    HEADING: 'Encabezado',
    INFORMATION: 'Información',
    INFO_TEXT: 'Información',
    DIVIDER: 'Divisor',
    FILE_UPLOAD: 'Subida de archivo',
    PHOTO: 'Foto',
    IMAGE_GALLERY: 'Galería de imágenes',
    SIGNATURE: 'Firma',
    CONSENT: 'Consentimiento / privacidad',
    PRODUCT_SINGLE: 'Selección de producto',
    PRODUCT_MULTIPLE: 'Múltiples productos',
    PRODUCT_MULTI: 'Múltiples productos',
    PRODUCT_CATALOG: 'Catálogo de productos',
    PRODUCT_QUANTITY_LIST: 'Lista de cantidad de productos',
    REPEATABLE_GROUP: 'Grupo repetible',
  },
  scopes: {
    EXISTING_CUSTOMER: 'Cliente existente',
    NEW_CUSTOMER: 'Nuevo cliente',
    PROSPECT: 'Prospecto',
    SUPPLIER: 'Proveedor',
    PARTNER: 'Socio comercial',
    PARTNERLESS: 'Sin socio',
    OTHER: 'Otro propósito',
  },
  cockpit: {
    title: 'Cabina de servicio de campo',
    subtitle: 'Iniciar, continuar y revisar cuestionarios de manera segura.',
    newRun: 'Nuevo cuestionario',
    partnerless: 'Cuestionario sin socio',
    today: 'Ejecuciones de hoy',
    drafts: 'Borradores',
    paused: 'Cuestionarios en pausa',
    unsynced: 'No sincronizado',
    followUp: 'Revisión requerida',
    recentTemplates: 'Plantillas usadas recientemente',
    recentPartners: 'Socios usados recientemente',
    search: 'Buscar ejecuciones',
    searchPlaceholder: 'Plantilla, socio o contacto',
    allStatuses: 'Todos los estados',
    allTemplates: 'Todas las plantillas',
    empty: 'Aún no hay ejecuciones de cuestionarios.',
    emptyHint: 'Inicie el primer cuestionario desde el panel de control de servicio de campo.',
    loadError: 'No se pudo cargar el panel de control de servicio de campo.',
    summaryLoadError: 'No se pudieron cargar las métricas del panel de control.',
    continue: 'Continuar',
    review: 'Revisar',
    progress: '{{value}}%',
  },
  start: {
    title: 'Nuevo cuestionario',
    subtitle: 'Seleccione un socio, contacto y plantilla publicada.',
    context: 'Contexto',
    withPartner: 'Con socio comercial',
    withoutPartner: 'Sin un socio existente',
    partner: 'Socio comercial',
    partnerSearch: 'Buscar socios',
    partnerSearchPlaceholder: 'Compañía, nombre, correo electrónico o número de socio',
    contact: 'Contacto',
    noContact: 'Sin contacto',
    template: 'Plantilla',
    matchingTemplates: 'Plantillas coincidentes',
    extendedTemplates: 'Otras plantillas publicadas',
    showExtended: 'Mostrar selección extendida',
    noTemplates: 'No hay plantilla publicada disponible para este contexto.',
    create: 'Crear cuestionario',
    creating: 'Creando cuestionario',
    created: 'El cuestionario fue creado.',
    createError: 'No se pudo crear el cuestionario.',
    partnerlessData: 'Detalles de contacto opcionales',
    company: 'Empresa',
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    address: 'Dirección',
    source: 'Fuente',
    note: 'Nota',
    contactConsent: 'Se ha dado consentimiento para ser contactado',
    sourcePlaceholder: 'p.ej. feria comercial o visita de campo',
    noPartnerRequired:
      'Todos los datos de contacto pueden permanecer vacíos a menos que sean requeridos por la plantilla.',
    fromPartner: 'Iniciar cuestionario',
    fromContact: 'Iniciar cuestionario para contacto',
  },
  run: {
    loading: 'Cargando cuestionario.',
    loadError: 'No se pudo cargar el cuestionario.',
    notFound: 'El cuestionario no se encontró o no se puede abrir.',
    answers: 'Respuestas',
    files: 'Archivos y fotos',
    products: 'Productos',
    internal: 'Solo empleados',
    required: 'Campo obligatorio',
    notApplicable: 'No aplicable',
    hidden: 'Oculto por regla',
    saveState: 'Estado de guardado',
    saved: 'Todos los cambios guardados.',
    saving: 'Guardando cambios.',
    saveFailed: 'No se pudieron guardar los cambios.',
    localSaved: 'Borrador cifrado en este dispositivo.',
    start: 'Iniciar cuestionario',
    pause: 'Pausar',
    resume: 'Reanudar',
    abandon: 'Abandonar',
    complete: 'Completar cuestionario',
    completeTitle: '¿Completar cuestionario?',
    completeDescription: 'Las respuestas serán validadas en el servidor y luego bloqueadas.',
    completeSuccess: 'El cuestionario fue completado.',
    completeError: 'No se pudo completar el cuestionario.',
    pauseSuccess: 'El cuestionario fue pausado.',
    abandonTitle: '¿Abandonar cuestionario?',
    abandonDescription: 'El abandono queda registrado en la auditoría.',
    abandonSuccess: 'El cuestionario fue abandonado.',
    customerMode: 'Iniciar modo cliente',
    customerModeHint: 'Verificar el socio y la plantilla antes de entregar el dispositivo.',
    handoverTitle: 'Entregar dispositivo al cliente',
    handoverDescription:
      'El modo cliente oculta la interfaz ERP y muestra solo las preguntas aprobadas.',
    handoverConfirm: 'Activar modo cliente',
    revision: 'Crear revisión de corrección',
    sectionProgress: 'Sección {{current}} de {{total}}',
    questionProgress: 'Pregunta {{current}} de {{total}}',
    validationError: 'Por favor revise los campos obligatorios resaltados.',
  },
  renderer: {
    yes: 'Sí',
    no: 'No',
    choose: 'Por favor seleccione',
    search: 'Opciones de búsqueda',
    noOptions: 'No hay opciones coincidentes',
    selectedCount: '{{count}} seleccionado',
    addGroup: 'Agregar otra entrada',
    removeGroup: 'Eliminar entrada',
    groupLabel: 'Entrada {{index}}',
    repeatMissing: 'La pregunta secundaria configurada no está disponible.',
    repeatUnsupported:
      '“{{label}}” no se puede almacenar de forma segura dentro de un grupo repetible.',
    addressStreet: 'Calle',
    addressHouseNumber: 'Número de casa',
    addressPostalCode: 'Ciudad',
    addressCity: 'Ciudad',
    addressCountry: 'País',
    clear: 'Borrar entrada',
    stars: '{{count}} de {{max}} estrellas',
    signatureHint: 'Por favor firme dentro del campo.',
    signerName: 'Nombre de la persona que firma',
    signatureChooseImage: 'Elegir firma en PNG',
    signatureClear: 'Borrar firma',
    signatureDisclaimer: 'La firma dibujada no es una firma electrónica calificada.',
    consentName: 'Nombre de la persona que confirma',
    consentConfirmed: 'Confirmo el consentimiento mostrado.',
    consentVersion: 'Versión del documento {{version}}',
  },
  media: {
    addFile: 'Elegir archivo',
    takePhoto: 'Tomar foto',
    takeRearPhoto: 'Usar cámara trasera',
    takeFrontPhoto: 'Usar cámara frontal',
    chooseGallery: 'Elegir de la galería',
    preview: 'Vista previa',
    previewReady: 'Vista previa – aún no aceptada',
    accept: 'Aceptar foto o archivo',
    retake: 'Volver a tomar',
    rotate: 'Rotar',
    remove: 'Eliminar archivo',
    description: 'Descripción',
    queued: 'En cola para subir',
    uploading: 'Subir {{progress}}%',
    uploaded: 'Subido de manera segura',
    uploadFailed: 'La subida falló',
    deleteFailed: 'No se pudo eliminar el archivo de manera segura.',
    retryUpload: 'Reintentar subida',
    cameraUnavailable: 'La cámara no está disponible en este navegador.',
    permissionDenied: 'No se permitió el acceso a la cámara. Verifique el permiso del navegador.',
    invalidFile: 'El archivo no cumple con el formato o tamaño permitido.',
    metadataHint:
      'Los metadatos de la imagen se eliminan en el servidor antes del almacenamiento permanente.',
    empty: 'No se seleccionó ningún archivo.',
  },
  products: {
    search: 'Buscar productos',
    searchPlaceholder: 'Nombre o número del producto',
    empty: 'No se encontraron productos coincidentes.',
    unknown: 'Ya no está en el catálogo actual',
    loadError: 'No se pudieron cargar los productos.',
    selected: 'Seleccionado',
    selectedProduct: 'Producto seleccionado',
    select: 'Seleccionar producto',
    remove: 'Eliminar producto',
    articleNumber: 'Número de producto',
    quantity: 'Cantidad solicitada',
    packaging: 'Unidad de embalaje',
    packagingLabel: '{{name}} ({{code}})',
    interest: 'Interés',
    currentProduct: 'Producto competidor actual',
    currentUse: 'El producto está en uso actualmente',
    comparisonGroup: 'Comparación de productos / grupo de comparación',
    plannedPurchaseDate: 'Fecha de compra planificada',
    note: 'Comentario',
    photo: 'Foto del producto',
    photoFileName: 'Foto del producto',
    wishlist: 'Agregar a la lista de deseos',
    priceRestricted: 'Los precios no se muestran en esta vista de cliente.',
    available: 'Disponible',
    unavailable: 'Actualmente no disponible',
    interestLevels: { NONE: 'Sin interés', LOW: 'Bajo', MEDIUM: 'Medio', HIGH: 'Alto' },
  },
  customer: {
    completedBrand: 'Cuestionario',
    loading: 'Abriendo cuestionario de manera segura.',
    unavailableTitle: 'Cuestionario no disponible',
    unavailable:
      'La sesión en modo cliente ha expirado o terminado. Por favor, devuelva el dispositivo al empleado.',
    fullscreen: 'Abrir pantalla completa',
    fullscreenExit: 'Salir de pantalla completa',
    fullscreenFailed: 'El navegador no pudo activar el modo de pantalla completa.',
    welcomeHeading: 'Bienvenido',
    privacyNoticeHeading: 'Aviso de privacidad',
    titleImageAlt: 'Imagen de título para {{title}}',
    privacyTitle: 'El contenido está oculto',
    privacyDescription: 'La vista se bloqueó debido a inactividad o cambio de pestaña.',
    privacyAction: 'Entregar al empleado',
    inactive: 'La vista se bloqueó debido a inactividad.',
    tabHidden: 'El contenido permanece oculto después de cambiar de pestaña.',
    previous: 'Atrás',
    next: 'Siguiente',
    finish: 'Enviar respuestas',
    thankYouTitle: 'Gracias',
    thankYou:
      'Sus respuestas se enviaron de forma segura. Por favor, devuelva el dispositivo al empleado.',
    noErpAccess: 'Esta vista no proporciona acceso al ERP.',
    unlockTitle: 'Desbloqueo de empleado',
    unlockDescription:
      'Volver a la revisión interna requiere una verificación renovada del empleado.',
    password: 'Contraseña actual del empleado',
    unlock: 'Revisar desbloqueo',
    unlockFailed: 'La verificación del empleado falló.',
    unlockSuccess: 'La revisión interna ha sido desbloqueada.',
    cleanupFailed:
      'Los datos locales del cuestionario aún no pudieron eliminarse de forma segura. Por favor, inténtelo de nuevo.',
    cleanupRetry: 'Eliminar datos locales nuevamente',
    securityLimit:
      'El modo cliente es una pantalla de privacidad dentro de la aplicación web. No puede controlar completamente las funciones del sistema operativo, capturas de pantalla u otras pestañas del navegador.',
  },
  offline: {
    supported: 'Uso seguro sin conexión disponible',
    unavailable: 'El uso seguro sin conexión no está disponible en este navegador.',
    unavailableSensitive:
      'Esta plantilla sensible no puede usarse sin conexión sin cifrado seguro.',
    encryption:
      'Los borradores y medios locales están cifrados con Web Crypto y almacenados en IndexedDB.',
    preparing: 'Preparando datos sin conexión.',
    prepared: 'La plantilla está disponible sin conexión.',
    packageCount: '{{count}} plantilla(s) sin conexión precargadas de forma segura.',
    preloadFailed: 'No se pudieron actualizar las plantillas sin conexión.',
    partnerContextRequired:
      'Los cuestionarios relacionados con socios solo se pueden iniciar sin conexión con el contexto del socio precargado de forma segura.',
    localRunCreated: 'El cuestionario fue creado de forma segura sin conexión.',
    customerPageUnavailable:
      'Esta página aún no se ha precargado de forma segura. Reconéctese para continuar.',
    customerCompletionPending:
      'Las respuestas están cifradas en este dispositivo y se completarán después de reconectarse.',
    localRunSyncing: 'El cuestionario sin conexión se está sincronizando con el servidor.',
    localRunConflict:
      'El estado del servidor ha cambiado. Los datos locales permanecen cifrados y disponibles para recuperación.',
    cleanup: 'Los datos locales fueron eliminados después de una sincronización exitosa.',
  },
  postprocess: {
    title: 'Revisar',
    subtitle: 'Revisar resultados y aplicar acciones de ERP deliberadamente.',
    completeness: 'Verificación de integridad',
    complete: 'Completo',
    incomplete: 'Incompleto',
    partnerAssignment: 'Asignación de socio',
    currentPartner: 'Socio asignado',
    partnerless: 'Aún no se ha asignado a un socio',
    searchPartner: 'Buscar socio existente',
    linkPartner: 'Vincular socio',
    linked: 'El socio comercial fue vinculado.',
    linkError: 'No se pudo vincular el socio comercial.',
    createProspect: 'Crear prospecto',
    createCustomer: 'Crear cliente',
    duplicates: 'Posibles duplicados',
    duplicateCheck: 'Verificación de duplicados antes de la creación',
    noDuplicates: 'No se encontraron duplicados posibles.',
    duplicatesAcknowledged:
      'Revisé los posibles duplicados y confirmo la creación de este registro.',
    conversionConfirmation:
      'Revise la vista previa de los datos maestros. La lógica existente del socio crea y enlaza el registro solo después de su confirmación.',
    confirmConversion: 'Confirmar creación y enlace',
    converted: '{{name}} fue creado y enlazado al cuestionario.',
    conversionError:
      'No se pudo crear el registro. Revise los campos obligatorios y posibles duplicados.',
    proposedActions: 'Acciones sugeridas del ERP',
    preview: 'Vista previa de transferencia',
    confirm: 'Ejecutar acción seleccionada',
    confirmationRequired: 'La acción se ejecuta solo después de su confirmación explícita.',
    noSilentChanges: 'Ningún dato maestro se cambia silenciosamente.',
    actionSuccess: 'La acción del ERP se completó.',
    actionError: 'No se pudo completar la acción del ERP.',
    dueAt: 'Vencido en',
    assignmentRequired: 'Se debe asignar un socio comercial antes de ejecutar esta acción.',
    contactData: 'Nuevos datos de contacto',
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Dirección de correo electrónico',
    phone: 'Número de teléfono',
    leadStatus: 'Nueva etapa de pipeline',
    leadStatuses: {
      NEW: 'Nuevo',
      CONTACTED: 'Contactado',
      QUALIFIED: 'Calificado',
      PROPOSAL_SENT: 'Propuesta enviada',
      NEGOTIATION: 'Negociación',
      WON: 'Ganado',
      LOST: 'Perdido',
    },
    actions: {
      CREATE_QUOTE_DRAFT: 'Crear borrador de cotización',
      CREATE_ORDER_DRAFT: 'Crear borrador de pedido',
      CREATE_PROSPECT_NEED: 'Registrar necesidad del prospecto',
      CREATE_PARTNER_NOTE: 'Crear nota de socio',
      CREATE_FOLLOW_UP: 'Crear seguimiento',
      CREATE_TASK: 'Crear tarea',
      ADD_CONTACT: 'Agregar contacto',
      UPDATE_PROSPECT_PIPELINE: 'Actualizar pipeline del prospecto',
      EXPOSE_DMS_FILES: 'Mostrar archivos en el registro del socio',
      SAVE_PRODUCT_INTEREST: 'Guardar interés en producto',
      ADD_PRODUCT_WATCHLIST: 'Agregar productos a la lista de seguimiento',
    },
  },
  templates: {
    title: 'Plantillas de cuestionarios',
    subtitle: 'Crear, validar y publicar plantillas versionadas.',
    create: 'Nueva plantilla',
    createTitle: 'Crear plantilla',
    internalName: 'Nombre interno',
    visibleTitle: 'Título visible',
    description: 'Descripción',
    language: 'Idioma',
    applications: 'Alcances de la aplicación',
    version: 'Versión {{version}}',
    updatedAt: 'Actualizado {{date}}',
    empty: 'Aún no hay plantilla de cuestionario.',
    loadError: 'No se pudieron cargar las plantillas.',
    created: 'La plantilla fue creada.',
    duplicate: 'Plantilla duplicada',
    archive: 'Archivar plantilla',
    archived: 'La plantilla fue archivada.',
    edit: 'Abrir creador',
  },
  builder: {
    title: 'Creador de formularios',
    back: 'Volver a plantillas',
    palette: 'Componentes',
    workspace: 'Formulario',
    properties: 'Propiedades',
    templateProperties: 'Plantilla',
    sections: 'Secciones',
    addSection: 'Agregar sección',
    sectionTitle: 'Encabezado de sección',
    sectionDescription: 'Descripción de la sección',
    untitledSection: 'Sección sin título',
    untitledQuestion: 'Pregunta sin título',
    selectHint: 'Seleccione una pregunta o sección.',
    dragHint: 'Arrastre o use el teclado para insertar en el formulario.',
    keyboardHint: 'Espacio para recoger, teclas de flecha para mover, espacio para soltar.',
    save: 'Guardar borrador',
    saved: 'El borrador de la plantilla fue guardado.',
    saveError: 'No se pudo guardar el borrador de la plantilla.',
    unsaved: 'Cambios no guardados',
    discardTitle: '¿Descartar los cambios no guardados?',
    discardDescription:
      'Cambiar de versiones descarta los cambios en esta versión que aún no se han guardado.',
    discardChanges: 'Descartar cambios',
    validate: 'Validar',
    valid: 'La plantilla está lista para publicar.',
    invalid: 'La plantilla aún contiene errores comerciales.',
    publish: 'Publicar',
    publishTitle: '¿Publicar la versión de la plantilla?',
    publishDescription: 'La versión publicada se congelará e inmutable.',
    published: 'La versión de la plantilla fue publicada.',
    publishError: 'No se pudo publicar la versión de la plantilla.',
    preview: 'Vista previa',
    previewHint: 'Revisar la presentación y lógica en los anchos de dispositivo compatibles.',
    previewDevice: 'Previsualizar dispositivo',
    devices: { phone: 'Teléfono', tablet: 'Tableta', desktop: 'Escritorio' },
    addQuestion: 'Agregar pregunta',
    createDraft: 'Crear nueva versión de borrador',
    deleteSection: 'Eliminar sección',
    repeatChild: 'Pregunta hija',
    copySuffix: '(copiar)',
    duplicateQuestion: 'Duplicar pregunta',
    deleteQuestion: 'Eliminar pregunta',
    moveUp: 'Mover hacia arriba',
    moveDown: 'Mover hacia abajo',
    internalKey: 'Clave interna estable',
    label: 'Etiqueta',
    helpText: 'Texto de ayuda',
    placeholder: 'Marcador de posición',
    prefillPartnerField: 'Rellenar desde el campo del socio comercial',
    erpTargetField: 'Mapeo de campos ERP posterior',
    analyticsKey: 'Clave de análisis',
    required: 'Requerido',
    internal: 'Solo interno',
    customerVisible: 'Visible en modo cliente',
    searchable: 'Habilitado para análisis',
    sensitive: 'Datos sensibles',
    sensitivity: {
      NONE: 'Sin clasificación sensible',
      PERSONAL: 'Datos personales',
      SPECIAL_CATEGORY: 'Categoría especial de datos personales',
      CONFIDENTIAL_BUSINESS: 'Datos comerciales confidenciales',
    },
    minLength: 'Longitud mínima',
    maxLength: 'Longitud máxima',
    minValue: 'Valor mínimo',
    maxValue: 'Valor máximo',
    decimals: 'Decimales',
    step: 'Paso',
    address: {
      requireStreet: 'Requerir calle',
      requirePostalCode: 'Requerir código postal',
      requireCity: 'Requerir ciudad',
      requireCountry: 'Requerir país',
    },
    pattern: 'Expresión regular segura',
    validationMessage: 'Mensaje de validación',
    defaultValue: 'Valor por defecto',
    noDefault: 'Sin valor por defecto',
    clearDefault: 'Borrar valor por defecto',
    options: 'Opciones de elección',
    optionValue: 'Valor estable',
    optionLabel: 'Etiqueta',
    optionDescription: 'Descripción',
    translations: 'Traducciones',
    primaryLanguage: 'Idioma principal',
    locales: {
      tr: 'Turco',
      fr: 'Francés',
      es: 'Español',
      de: 'Alemán',
      en: 'Inglés',
    },
    titleImage: 'Imagen de título opcional del DMS',
    titleImageUpload: 'Subir imagen de título',
    titleImageRemove: 'Eliminar imagen de título',
    titleImageEmpty: 'Aún no hay imágenes disponibles en DMS.',
    titleImageError: 'No se pudieron cargar ni subir las imágenes de DMS.',
    titleImageDmsPermission:
      'Se requiere permiso de lectura de DMS para seleccionar una imagen de título.',
    removeChip: 'Eliminar {{value}}',
    addOption: 'Agregar opción',
    moveOptionUp: 'Mover opción hacia arriba',
    moveOptionDown: 'Mover opción hacia abajo',
    allowedFileFormats: 'Formatos de archivo permitidos',
    fileFormats: {
      PDF: 'PDF',
      JPEG: 'JPEG',
      PNG: 'PNG',
      WEBP: 'WebP',
      DOCX: 'Word (DOCX)',
      XLSX: 'Excel (XLSX)',
      TXT: 'Archivo de texto (TXT)',
      CSV: 'CSV',
    },
    newOption: 'Opción {{index}}',
    removeOption: 'Eliminar opción',
    randomizeOptions: 'Aleatorizar opciones',
    minSelections: 'Selecciones mínimas',
    maxSelections: 'Selecciones máximas',
    maxFiles: 'Número máximo de archivos',
    maxFileSizeMb: 'Tamaño máximo de archivo en MB',
    requireFileDescription: 'Requerir descripción del archivo',
    imageSource: 'Fuente de imagen permitida',
    imageSources: { CAMERA: 'Cámara', GALLERY: 'Galería', BOTH: 'Cámara y galería' },
    requireSignerName: 'Requerir nombre del firmante',
    logic: 'Lógica condicional',
    addRule: 'Agregar regla',
    removeRule: 'Eliminar regla',
    operators: {
      EQUALS: 'es igual a',
      NOT_EQUALS: 'no es igual a',
      CONTAINS: 'contiene',
      NOT_CONTAINS: 'no contiene',
      GREATER_THAN: 'mayor que',
      LESS_THAN: 'menor que',
      EMPTY: 'está vacío',
      NOT_EMPTY: 'no está vacío',
      ONE_OF: 'uno de',
      ALL_OF: 'todo',
      BETWEEN: 'entre',
    },
    consentText: 'Texto de consentimiento',
    consentPurpose: 'Propósito del consentimiento',
    consentSignature: 'Requerir firma',
    repeatChildren: 'Preguntas para niños',
    pageBreak: 'Salto de página después de esta sección',
    completionSection: 'Sección de finalización',
    consentDocumentVersion: 'Versión del documento',
    consentWithdrawal: 'Aviso de retiro',
    consentName: 'Requerir nombre de la persona que confirma',
    productFilters: 'Filtros de productos',
    productDisplay: 'Campos de visualización y respuesta de productos',
    productFilter: {
      productIds: 'Productos específicos',
      categoryIds: 'Categorías',
      productGroups: 'Grupos de productos',
      tags: 'Etiquetas',
      rootCategoryId: 'Categoría raíz',
      searchProducts: 'Buscar nombre o número de producto',
      searchCategories: 'Buscar categorías',
      selectedItem: 'Producto seleccionado',
      removeSelected: 'Eliminar producto seleccionado',
      clearProducts: 'Borrar selección de productos',
      allCategories: 'Todas las categorías',
      productTypes: 'Tipos de productos',
      activeOnly: 'Solo productos activos',
      customerSpecificAssortment: 'Selección específica para el cliente',
      availableOnly: 'Solo stock disponible',
      includeSubcategories: 'Incluir subcategorías',
    },
    productTypes: {
      STOCK: 'Artículo en stock',
      NON_STOCK: 'Artículo fuera de stock',
      SERVICE: 'Servicio',
      SET: 'Conjunto',
      DEPOSIT: 'Artículo en depósito',
    },
    productDisplayFields: {
      showImage: 'Imagen del producto',
      showName: 'Nombre del producto',
      showArticleNumber: 'Número de producto',
      showDescription: 'Descripción',
      showPackaging: 'Unidades de embalaje',
      showPrice: 'Precio',
      showStock: 'Stock',
      showCategories: 'Categorías',
      showTags: 'Etiquetas',
      allowQuantity: 'Entrada de cantidad',
      allowInterest: 'Interés',
      allowCurrentUse: 'Uso actual',
      allowPlannedPurchaseDate: 'Fecha de compra planificada',
      allowCompetitorProduct: 'Producto competidor',
      allowRemark: 'Comentario',
      allowComparison: 'Comparación de productos',
      allowProductPhoto: 'Foto del producto',
      allowWatchlist: 'Lista de vigilancia',
    },
    minRows: 'Entradas mínimas',
    maxRows: 'Entradas máximas',
    addButtonLabel: 'Etiqueta del botón de añadir',
    ruleIf: 'Si',
    ruleOperator: 'Operador',
    ruleValue: 'Valor de comparación',
    conditionSourceQuestion: 'Pregunta de origen de la condición',
    conditionOperator: 'Operador de condición',
    ruleAction: 'Entonces',
    combination: 'Combinación',
    settings: 'Configuración de la plantilla',
    welcomeText: 'Texto de bienvenida',
    completionText: 'Texto de finalización',
    privacyText: 'Texto de privacidad',
    estimatedMinutes: 'Duración estimada en minutos',
    useTenantLogo: 'Mostrar logo del inquilino',
    customerMode: 'Permitir modo cliente',
    allowBackNavigation: 'Permitir navegación hacia atrás',
    fullscreen: 'Ofrecer pantalla completa',
    idleLockMinutes: 'Bloqueo por inactividad en minutos',
    offlineMode: 'Permitir uso sin conexión',
    allowSensitiveOffline: 'Permitir datos sensibles sin conexión',
    preloadProductLimit: 'Máximo de productos para precargar',
    progress: 'Indicador de progreso',
    oneQuestionPerPage: 'Una pregunta por página',
    oneSectionPerPage: 'Una sección por página',
    hiddenAnswerPolicy: 'Manejo de respuestas ocultas',
    hiddenPolicies: {
      DELETE: 'Eliminar respuesta',
      MARK_NOT_APPLICABLE: 'Marcar como no aplicable',
    },
    conditions: 'Condiciones',
    addCondition: 'Agregar condición',
    removeCondition: 'Eliminar condición',
    logicTarget: 'Objetivo',
    combinators: { AND: 'Y', OR: 'O' },
    logicActions: {
      SHOW: 'Mostrar',
      HIDE: 'Ocultar',
      SKIP_TO_SECTION: 'Saltar a la sección',
      MARK_NOT_APPLICABLE: 'Marcar como no aplicable',
    },
    optimisticConflict: 'La plantilla cambió mientras tanto. Recargar la última versión.',
  },
  results: {
    title: 'Resultados del cuestionario',
    subtitle: 'Filtrar, revisar y exportar de manera segura las ejecuciones del cuestionario.',
    detailTitle: 'Detalles del resultado',
    analytics: 'Analítica',
    search: 'Resultados de la búsqueda',
    template: 'Plantilla',
    version: 'Versión',
    status: 'Estado',
    period: 'período',
    employee: 'Empleado',
    partner: 'Socio',
    partnerRole: 'Rol del socio',
    partnerless: 'Sin socio',
    completeness: 'Integridad',
    product: 'Producto',
    date: 'Fecha',
    contact: 'Contacto',
    duration: 'Duración',
    durationMinutes: '{{value}} min',
    attachments: 'Archivos / fotos',
    selectedProducts: 'Productos',
    syncStatus: 'Sincronización',
    postprocessStatus: 'Revisar',
    empty: 'Ningún resultado coincide con estos filtros.',
    loadError: 'No se pudieron cargar los resultados.',
    exportCsv: 'Exportar lista como CSV',
    exportJson: 'Crear exportación estructurada en JSON',
    exportPdf: 'Abrir informe en PDF',
    exportSuccess: 'La exportación fue creada.',
    exportQueued: 'La exportación se inició como un trabajo en segundo plano.',
    exportJobTitle: '{{format}} exportar',
    exportRows: '{{count}} resultados',
    exportProgress: 'Progreso del trabajo de exportación',
    exportDownload: 'Descargar exportación',
    exportFailed: 'La exportación falló ({{code}}).',
    exportUnknownError: 'Error desconocido',
    exportLoadError: 'No se pudieron cargar los trabajos de exportación.',
    exportStatuses: {
      PENDING: 'En cola',
      PROCESSING: 'Procesando',
      COMPLETED: 'Listo',
      FAILED: 'Fallido',
    },
    answers: 'Respuestas por sección',
    consents: 'Consentimientos',
    audit: 'Cronograma de auditoría',
    transfers: 'Transferencias ERP',
    revisions: 'Revisiones',
    syncEvents: 'Eventos de sincronización',
    distribution: 'Distribución de respuestas',
    average: 'Promedio',
    trend: 'Tendencia a lo largo del tiempo',
    completionRate: 'Tasa de finalización',
    abandonmentRate: 'Tasa de abandono',
    averageDuration: 'Tiempo promedio de finalización',
    noAnalytics: 'No se han habilitado preguntas para análisis.',
    analyticsError: 'No se pudieron cargar los análisis agregados.',
    allTemplates: 'Todas las plantillas',
    allRoles: 'Todos los roles de socios',
    allCompleteness: 'Completos e incompletos',
    employeeId: 'ID del empleado',
    productId: 'ID del producto',
    productCategory: 'Categoría de producto',
    categoryId: 'ID de categoría',
    analyticsKey: 'Clave de análisis',
    answerOperator: 'Operador de respuesta',
    answerValue: 'Valor de respuesta',
    startedCount: 'Iniciado',
    completedCount: 'Completado',
    numericSummary: 'Promedio {{average}} · Mínimo {{minimum}} · Máximo {{maximum}}',
    productInterests: 'Intereses de producto',
    roleDistribution: 'Distribución por rol de socio',
    startedShort: 'S {{value}}',
    completedShort: 'C {{value}}',
    abandonedShort: 'A {{value}}',
    partnerRoles: {
      CUSTOMER: 'Cliente',
      PROSPECT: 'Prospecto',
      SUPPLIER: 'Proveedor',
      PARTNERLESS: 'Sin socio',
    },
    dateFrom: 'Desde',
    dateTo: 'Hasta',
    revoked: 'Revocado',
    revisionNumber: 'Revisión {{number}}',
    createRevision: 'Crear revisión de corrección',
    revisionDescription:
      'La corrección crea una nueva revisión rastreable. La original permanece sin cambios.',
    revisionReason: 'Motivo de la corrección',
    previewRevision: 'Revisar corrección',
    confirmRevision: 'Crear revisión',
    revisionCreated: 'La revisión de corrección fue creada.',
    revisionError: 'No se pudo crear la revisión de corrección.',
    systemActor: 'Sistema',
    targetEntity: 'Objetivo: {{type}} · {{id}}',
    eventStatuses: {
      PENDING: 'Pendiente',
      PROCESSING: 'Procesando',
      SUCCEEDED: 'Exitoso',
      FAILED: 'Fallido',
    },
    syncEventTypes: {
      DRAFT_CREATED: 'Borrador local creado',
      ANSWERS_SAVED: 'Respuestas sincronizadas',
      ATTACHMENT_QUEUED: 'Archivo en cola',
      ATTACHMENT_UPLOADED: 'Archivo subido',
      COMPLETION_REQUESTED: 'Solicitud de finalización',
      COMPLETION_CONFIRMED: 'Finalización confirmada',
      LOCAL_DATA_CLEARED: 'Datos locales borrados',
    },
    auditActions: {
      CREATE: 'Creado',
      UPDATE: 'Actualizado',
      DELETE: 'Eliminado',
      LOGIN: 'Iniciar sesión',
      LOGOUT: 'Cerrar sesión',
      EXPORT: 'Exportado',
      POST: 'Procesado',
      APPROVE: 'Aprobado',
      CANCEL: 'Cancelado',
      VIEW: 'Visto',
    },
    postprocess: {
      NOT_REQUIRED: 'No requerido',
      REQUIRED: 'Requerido',
      IN_PROGRESS: 'En progreso',
      COMPLETED: 'Completado',
    },
  },
  partnerRecord: {
    title: 'Cuestionarios para este socio comercial',
    subtitle: 'Todas las ejecuciones vinculadas con su estado, respuestas, medios y resultados.',
    empty: 'Ningún cuestionario ha sido completado para este socio comercial aún.',
    loadError: 'No se pudieron cargar los cuestionarios vinculados.',
    open: 'Abrir cuestionario',
  },
  legalHold: {
    title: 'Retención legal',
    statuses: {
      NONE: 'Sin retención',
      ACTIVE: 'Activo',
      EXPIRED: 'Expirado',
    },
    noneDescription: 'Esta ejecución de cuestionario no está sujeta a una retención legal.',
    indefinite: 'Retenido indefinidamente',
    untilValue: 'Retenido hasta {{value}}',
    set: 'Establecer retención',
    change: 'Cambiar retención',
    release: 'Liberar retención',
    setTitle: 'Establecer retención legal',
    setDescription:
      'Una retención activa evita la limpieza automática y la anonimización de esta ejecución del cuestionario.',
    reason: 'Motivo de la retención legal',
    until: 'Retener hasta (opcional)',
    untilHint: 'Sin una hora de finalización, la retención permanece activa indefinidamente.',
    untilInvalid: 'La hora de finalización debe estar en el futuro.',
    confirmSet: 'Establecer retención legal',
    setSuccess: 'La retención legal fue guardada.',
    saveError: 'No se pudo guardar la retención legal.',
    releaseTitle: 'Liberar retención legal',
    releaseDescription:
      'Después de la liberación, la ejecución del cuestionario puede nuevamente ser limpiada o anonimizada según la política de retención.',
    releaseReason: 'Motivo para liberar la retención',
    confirmRelease: 'Liberar retención legal',
    releaseSuccess: 'La retención legal fue liberada.',
    releaseError: 'No se pudo liberar la retención legal.',
    loadError: 'No se pudo cargar la retención legal.',
  },
  settings: {
    title: 'Configuración de cuestionarios',
    subtitle:
      'Reglas de retención en todo el inquilino, modo cliente, uso sin conexión y reportes.',
    loading: 'Cargando configuraciones del cuestionario.',
    loadError: 'No se pudieron cargar las configuraciones del cuestionario.',
    invalid: 'Por favor, revise los valores ingresados.',
    saved: 'Las configuraciones del cuestionario fueron guardadas.',
    saveError: 'No se pudieron guardar las configuraciones del cuestionario.',
    retention: 'Retención y limpieza',
    retentionDays: 'Período de retención en días',
    abandonedDraftCleanupDays: 'Limpiar borradores abandonados después de días',
    customerMode: 'Modo cliente',
    customerSessionTtlMinutes: 'Duración máxima de la sesión en minutos',
    customerIdleLockMinutes: 'Bloqueo por inactividad en minutos',
    offlineAndReports: 'Uso sin conexión y reportes',
    offlineCatalogMaxProducts: 'Máximo de productos para precargar de manera segura',
    allowSensitiveOffline: 'Permitir almacenamiento fuera de línea cifrado de respuestas sensibles',
    createPdfOnCompletion: 'Crear un informe en PDF después de la finalización',
    attachPdfToPartner: 'Exponer el informe en PDF en el registro del socio',
  },
} as const;
